import { atom } from 'jotai';
import { debounce } from 'lodash';

const wiwAtom = atom(typeof window !== 'undefined' ? window.innerWidth : 0);

wiwAtom.onMount = (set) => {
  const handler = debounce(() => {
    set(window.innerWidth);
  }, 300);

  window.addEventListener('resize', handler);

  return () => {
    window.removeEventListener('resize', handler);
    handler.cancel();
  };
};

export default wiwAtom;
